import { atualizarCriterioSchema, criarCriterioSchema, type CriarCriterioDto, type CriterioBase, type CriterioResponse } from '@triade/contracts';

export const BASE_ROTULO: Record<CriterioBase, string> = {
  M2: 'Metros quadrados (M²)',
  FUNCIONARIOS: 'Nº de funcionários alocados',
  SALARIO: 'Valor do salário',
  WATTS: 'Potencial em watts',
  VALOR_HORA_MAQUINA: 'Valor hora/máquina',
  MAQUINAS: 'Nº de máquinas alocadas',
};

export const BASES = Object.keys(BASE_ROTULO) as CriterioBase[];

/** Valores do formulario (o que o usuario digita/escolhe). Os centros ficam fora (lista dupla). */
export interface CriterioFormEntrada {
  identificador: string;
  descricao: string;
  base: CriterioBase;
  todosCentros: boolean;
  ativo: boolean;
}

export const CRITERIO_VAZIO: CriterioFormEntrada = { identificador: '', descricao: '', base: 'M2', todosCentros: true, ativo: true };

export function deCriterio(c: CriterioResponse): CriterioFormEntrada {
  return { identificador: c.identificador, descricao: c.descricao, base: c.base, todosCentros: c.todosCentros, ativo: c.ativo };
}

/** Centros do critério gravado, na ordem `ordem` (centroIds). */
export function centroIdsDoCriterio(c: CriterioResponse): string[] {
  return [...c.centros].sort((a, b) => a.ordem - b.ordem).map((x) => x.centroId);
}

export type ResultadoCorpo<T> = { ok: true; corpo: T } | { ok: false; campo?: string; mensagem: string };

/**
 * Monta o corpo para a API e valida pelo contrato. Com "considerar todos os centros", centroIds vai vazio (a API ignora).
 * Nao calcula nada: so reune campos e valida.
 */
export function montarCorpoCriterio(v: CriterioFormEntrada, considerados: readonly string[], editando: boolean): ResultadoCorpo<CriarCriterioDto & { ativo?: boolean }> {
  const entrada = {
    identificador: v.identificador,
    descricao: v.descricao,
    base: v.base,
    todosCentros: v.todosCentros,
    centroIds: v.todosCentros ? [] : [...considerados],
    ...(editando ? { ativo: v.ativo } : {}),
  };
  const r = editando ? atualizarCriterioSchema.safeParse(entrada) : criarCriterioSchema.safeParse(entrada);
  if (!r.success) {
    const primeira = r.error.issues[0];
    const campo = String(primeira?.path[0] ?? '');
    return { ok: false, campo: campo || undefined, mensagem: primeira?.message ?? 'Dados inválidos' };
  }
  return { ok: true, corpo: r.data as CriarCriterioDto & { ativo?: boolean } };
}
